import { I18nManager } from "react-native";
export const getIconPosition = (propIconPosition) => {
  return I18nManager.isRTL ? propIconPosition === "before" ? "after" : "before" : propIconPosition;
};
